import { render, staticRenderFns } from "./xy.vue?vue&type=template&id=81f7d152&scoped=true&lang=pug&"
import script from "./xy.vue?vue&type=script&lang=js&"
export * from "./xy.vue?vue&type=script&lang=js&"
import style0 from "./xy.vue?vue&type=style&index=0&id=81f7d152&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f7d152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('81f7d152', component.options)
    } else {
      api.reload('81f7d152', component.options)
    }
    module.hot.accept("./xy.vue?vue&type=template&id=81f7d152&scoped=true&lang=pug&", function () {
      api.rerender('81f7d152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/position/size/xy.vue"
export default component.exports